import Hloading from './loading.vue'

// const HLoading = {
//     install(Vue) {
//         if (typeof window !== 'undefined' && window.Vue) {
//             Vue = window.Vue
//         }
//         let tpl;
//         // 挂载到vue原型上，暴露两个方法
//         Vue.prototype.$hloading = {
//             show(){
//                 var loading = Vue.extend(require('./components/loading/loading.vue').default);
//                 // import Loading from './Loading.vue'
//                 console.log('new loading().$mount().$el',new loading().$mount().$el)
//                 tpl = new loading().$mount().$el;
//                 // debugger
//                 document.body.appendChild(tpl);
//                 return tpl
//             },
//             hidden(){
//                 return document.body.removeChild(tpl);
//             }
 
//         }
//     }

// }
const HLoading = {
  install: function(Vue) {
    Vue.component(Hloading.name, Hloading)
  }
}
// 这里的判断很重要
if (typeof window !== 'undefined' && window.Vue) { 
    window.Vue.use(HLoading) 
}
// export default comment

export default HLoading


// WEBPACK FOOTER //
// ./src/components/loading/index.js